export const CHECK_POPUPS = 'CHECK_POPUPS';

/**
 * @param {popupName} boolean
 */
export const checkPopups = (obj) => ({
    type: 'CHECK_POPUPS',
    payload: obj,
});
